<tt-page *ngIf="!!edit">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input ttLabel="stockplace_name" [ttModel]="edit.stockplace_name" ttReadonly></tt-input>
        <tt-date ttLabel="stockcount_date" [ttModel]="edit.stockcount_date" ttReadonly></tt-date>
        <tt-textarea ttLabel="infotext" [ttModel]="edit.infotext" ttReadonly></tt-textarea>
        <tt-button ttText="stockcountmenu_refresh_stock" (ttClick)="refreshChanges()" [ttSpin]="refreshing" ttIcon="fas fa-sync"></tt-button>
    </tt-card>
</tt-page>
